export type RadioItem = Readonly<{ id: string; value: string; label: string }>;

/**
 * Grouped radios sharing a **`name`** inside a **`fieldset`**.
 *
 * @param options - Shared **`name`**, legend text, radio rows with unique **`id`** each.
 * @returns **`HTMLFieldSetElement`** with **`qz-radio-group`** class.
 */
export function createRadioGroup(
  options: Readonly<{
    name: string;
    legend: string;
    items: ReadonlyArray<RadioItem>;
  }>,
): HTMLFieldSetElement {
  const fs = document.createElement("fieldset");
  fs.className = "qz-radio-group";

  const leg = document.createElement("legend");
  leg.className = "qz-radio-group__legend";
  leg.textContent = options.legend;
  fs.appendChild(leg);

  for (const item of options.items) {
    const row = document.createElement("div");
    row.className = "qz-radio";

    const input = document.createElement("input");
    input.type = "radio";
    input.className = "qz-radio__input";
    input.name = options.name;
    input.value = item.value;
    input.id = item.id;

    const lbl = document.createElement("label");
    lbl.className = "qz-radio__label";
    lbl.htmlFor = item.id;
    lbl.textContent = item.label;

    row.appendChild(input);
    row.appendChild(lbl);
    fs.appendChild(row);
  }

  return fs;
}
